/**
 * Соответствие «тип файла (по расширению имени) → имя иконки»
 */

export const typeIconMap: Record<string, string> = {
  // папка
  folder: "folder-closed",

  // документы
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  xlsm: "file-excel",
  xlsb: "file-excel",
  xltx: "file-excel",
  xltm: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  ppsx: "file-powerpoint",
  potx: "file-powerpoint",
  pdf: "file-pdf",

  // изображения
  jpg: "file-image",
  jpeg: "file-image",
  png: "file-image",
  gif: "file-image",
  bmp: "file-image",
  tiff: "file-image",
  svg: "file-image",
  ai: "file-image",
  eps: "file-image",
  webp: "file-image",
  raw: "file-image",
  psd: "file-image",
  ico: "file-image",

  // видео
  mp4: "file-video",
  mov: "file-video",
  mkv: "file-video",
  avi: "file-video",
  wmv: "file-video",
  flv: "file-video",
  webm: "file-video",
  mpeg: "file-video",
  mpg: "file-video",

  // аудио
  mp3: "file-audio",
  wav: "file-audio",
  flac: "file-audio",
  ogg: "file-audio",
  m4a: "file-audio",
  wma: "file-audio",
  ape: "file-audio",
  mid: "file-audio",
  opus: "file-audio",

  // архивы
  zip: "file-archive",
  rar: "file-archive",
  "7z": "file-archive",
  tar: "file-archive",
  gz: "file-archive",
  gzip: "file-archive",
  cab: "file-archive",
  sit: "file-archive",

  // текст
  txt: "file-text",
  log: "file-text",
  csv: "file-text",
  odt: "file-text",
  rtf: "file-text",
  epub: "file-text",
  fb2: "file-text",
  mobi: "file-text",

  // код
  html: "file-code",
  htm: "file-code",
  php: "file-code",
  asp: "file-code",
  jsp: "file-code",
  xhtml: "file-code",
  xml: "file-code",
  css: "file-code",
  js: "file-code",
};

/** Извлекает расширение из имени/пути файла (учитывает query/hash и tar.gz-подобные). */
export const getFileTypeFromString = (value: string): string => {
  if (!value) {
    return "";
  }

  const cleanValue = value.split(/[?#]/)[0];
  const fileName = cleanValue.split("/").pop();
  if (!fileName) {
    return "";
  }

  if (!fileName.includes(".")) {
    return "file-universal";
  }

  const parts = fileName.toLowerCase().split(".");
  if (parts.length > 2) {
    const lastTwo = parts.slice(-2).join(".");
    if (["tar.gz", "tar.bz2", "tar.xz"].includes(lastTwo)) {
      return lastTwo;
    }
  }

  return parts.pop() || "";
};

/** Имя иконки по имени файла; дефолт — file-universal. */
export const getFileIcon = (name: string): string =>
  typeIconMap[getFileTypeFromString(name)] || "file-universal";
